import { gql } from '@apollo/client';
import { CODE_FRAGMENT, IDENTIFIER_FRAGMENT } from '../../shared/fragments';

export const FETCH_ALL_MEDICATIONS_QUERY = gql`
  query fetchAllMedications(
    $sourceUrl: String
    $count: String
    $offset: Int
    $dateFilter: Float
    $statusFilter: String
    $searchFilter: String
  ) {
    fetchAllMedications(
      sourceUrl: $sourceUrl
      count: $count
      offset: $offset
      dateFilter: $dateFilter
      statusFilter: $statusFilter
      searchFilter: $searchFilter
    ) {
      medicationRequestList
      count
    }
  }
`;

export const FETCH_ALL_MEDICATIONS_STATEMENTS_QUERY = gql`
  query fetchMedicationStatement(
    $sourceUrl: String
    $count: String
    $offset: Int
    $dateFilter: Float
    $statusFilter: String
    $searchFilter: String
  ) {
    fetchMedicationStatement(
      sourceUrl: $sourceUrl
      count: $count
      offset: $offset
      dateFilter: $dateFilter
      statusFilter: $statusFilter
      searchFilter: $searchFilter
    ) {
      medicationStatementList
      count
    }
  }
`;

export const FETCH_ALL_MEDICATIONS_DISPENSES_QUERY = gql`
  query fetchMedicationDispense(
    $sourceUrl: String
    $count: String
    $offset: Int
    $dateFilter: Float
    $statusFilter: String
    $searchFilter: String
  ) {
    fetchMedicationDispense(
      sourceUrl: $sourceUrl
      count: $count
      offset: $offset
      dateFilter: $dateFilter
      statusFilter: $statusFilter
      searchFilter: $searchFilter
    ) {
      medicationDispenseList
      count
    }
  }
`;

export const FETCH_MEDICATION_STATEMENT_BY_ID_QUERY = gql`
  query fetchMedicationStatementById($medicationStatementId: String) {
    fetchMedicationStatementById(
      medicationStatementId: $medicationStatementId
    ) {
      id
      note {
        text
      }
      dosageInstruction {
        asNeededBoolean
        route {
          ...code
        }
        timing {
          repeat {
            boundsPeriod {
              start
              end
            }
            frequency
            period
            timeOfDay
          }
          code {
            ...code
          }
        }
        text
        method {
          text
        }
      }
      effective {
        effectivePeriod {
          effectivePeriod {
            start
            end
          }
        }
      }
      informationSource {
        display
      }
      medicationCodeableConcept {
        coding {
          system
          code
          display
        }
        text
      }
      identifier {
        ...identifier
      }
      medicationReference {
        reference
        display
      }
    }
  }
  ${CODE_FRAGMENT}
  ${IDENTIFIER_FRAGMENT}
`;

export const FETCH_MEDICATION_DISPENSE_BY_ID_QUERY = gql`
  query fetchMedicationDispenseById($medicationDispenseId: String) {
    fetchMedicationDispenseById(medicationDispenseId: $medicationDispenseId) {
      id
      note {
        text
      }
      dosageInstruction {
        asNeededBoolean
        route {
          ...code
        }
        timing {
          repeat {
            boundsPeriod {
              start
              end
            }
            frequency
            period
            timeOfDay
          }
          code {
            ...code
          }
        }
        text
        method {
          text
        }
      }
      medicationCodeableConcept {
        coding {
          system
          code
          display
        }
        text
      }
      identifier {
        ...identifier
      }
      medicationReference {
        reference
        display
      }
      receiver {
        display
        reference
      }
    }
  }
  ${CODE_FRAGMENT}
  ${IDENTIFIER_FRAGMENT}
`;

export const FETCH_MEDICATION_REQUEST_BY_ID_QUERY = gql`
  query fetchMedicationById($medicationId: String) {
    fetchMedicationById(medicationId: $medicationId) {
      medicationRequest
      docArn
      documentReferenceId
    }
  }
`;
